import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white text-gray-600 pt-16 pb-8">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-start">
          {/* Left side - Contact Info */}
          <div className="space-y-4 mb-8 md:mb-0">
            <h3 className="text-lg font-semibold text-black">{t('footer.contactUs')}</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone size={18} className="text-black flex-shrink-0" />
                <span className="text-gray-600">+1 (450) 805-3277</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} className="text-black flex-shrink-0" />
                <span className="text-gray-600">info@financesunshine.com</span>
              </div>
            </div>
          </div>
          
          {/* Right side - Credits */}
          <div className="text-right">
            <p className="text-gray-600 font-medium mb-2">{t('footer.byNeurodivers')}</p>
            <p className="text-gray-500">© {currentYear} Finance Sunshine. {t('footer.allRightsReserved')}.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;